/**
 * Ссылка на трейс транзакции в Grafana.
 *
 * Бэкенд вешает на спан атрибут `transaction.id` (observability_setup.py,
 * set_transaction_trace_context), трейсы уходят в Tempo — датасорс с uid
 * "tempo" из observability/grafana/provisioning/datasources.yml. Поэтому
 * ищем по TraceQL, а не по конкретному trace_id: его фронт не знает.
 *
 * Формат ссылки — Explore из Grafana 11 (`panes` + schemaVersion). В Grafana 9
 * и раньше параметр назывался `left` и имел другую структуру, так что при
 * понижении версии ссылка перестанет открываться.
 */

const GRAFANA_BASE = (
  process.env.REACT_APP_GRAFANA_URL || "https://grafanoman.payfinzora.com"
).replace(/\/+$/, "");

const TEMPO_UID = process.env.REACT_APP_GRAFANA_TEMPO_UID || "tempo";

/** Сколько назад искать. Трейсы живут не вечно, сутки — разумный компромисс. */
const LOOKBACK = "now-24h";

export const buildTraceUrl = (transactionId: string): string => {
  const panes = {
    fz: {
      datasource: TEMPO_UID,
      queries: [
        {
          refId: "A",
          datasource: { type: "tempo", uid: TEMPO_UID },
          queryType: "traceql",
          // Атрибут спана, а не ресурса — отсюда префикс span.
          // Без пробелов внутри: так запрос переживает любую трактовку "+"
          // на стороне Grafana.
          query: `{span.transaction.id="${transactionId}"}`,
          limit: 20,
        },
      ],
      range: { from: LOOKBACK, to: "now" },
    },
  };

  // URLSearchParams кодирует пробел как "+", и если Grafana разберёт параметр
  // обычным decodeURIComponent, плюсы останутся в тексте запроса. Кодируем сами.
  const panesParam = encodeURIComponent(JSON.stringify(panes));

  return `${GRAFANA_BASE}/explore?schemaVersion=1&orgId=1&panes=${panesParam}`;
};
